import React from 'react'
import { Link } from 'react-router-dom'

export default function Explore() {
    return (
      <div className="heroSection">
        <div className="container">
          <h1 style={{color:"black"}}>Your Next-Gen Software Partner Is Here</h1>
          <p>Tooliso turns bold ideas into bulletproof software. Whether you're launching a startup, scaling a SaaS, or automating operations — we engineer your competitive edge.</p>
          <Link to={'/write-for-us-saas'} className="heroAnchor" href="#features">
            <Link to={'/write-for-us-saas'}>Get a Quote</Link>
          </Link>
        </div>
      </div>
    )
}
